const GENERAL_TOPICS = [
  'Students’ attitudes towards AI tools for learning',
  'Students’ views on recycling on campus',
  'Students’ preferences for flexible working arrangements',
]
function cleanTopics(values) {
  return Array.isArray(values) ? [...new Set(values.filter(v => typeof v === 'string' && v.trim() && v.trim().length <= 500).map(v => v.trim()))].slice(0, 20) : []
}
export function recommendedTopics(prompt, configured) {
  const topics = cleanTopics(configured)
  if (topics.length) return { topics, source: 'configured' }
  const match = String(prompt || '').split(/(?:below are some possible topics for your consideration|suggested topics|possible topics|topic examples)\s*[:：]/i)[1]
  const legacy = cleanTopics((match || '').split('\n').filter(line => /^\s*(?:[-*•]|\d+[.)])\s*/.test(line)).map(line => line.replace(/^\s*(?:[-*•]|\d+[.)])\s*/, '')))
  return legacy.length ? {topics:legacy, source:'assignment'} : {topics:[...GENERAL_TOPICS],source:'general'}
}
export function normalizeTopicReply(value) {
  if (Array.isArray(value?.topics) && value.topics.some(topic => typeof topic === 'string' && topic.trim().length > 500)) throw new Error('Topic help returned a topic longer than 500 characters. Please retry.')
  const topics = cleanTopics(value?.topics).slice(0, 3)
  if (!topics.length || typeof value.feedback !== 'string') throw new Error('Topic help returned an incomplete reply. Please retry.')
  return { topics, feedback: value.feedback }
}
